import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { ROUTES } from '../../../constants/RouteNameMapping';
import { SelectedCompanyParam, SelectedTransactionParam } from '../finance-constants';
import { ITransactionDataModel } from '../../../data-models/transaction.data-model';

export function useTransactionHistoryAction() {
  const navigate = useNavigate();

  const navigateToTransactionHistory = useCallback(
    (transaction: ITransactionDataModel) => {
      const to = `/${ROUTES.FINANCE2}/${ROUTES.FINANCE2_OVERVIEW}/${ROUTES.FINANCE_DETAILS}/${ROUTES.FINANCE_TRANSACTIONS_3}/${ROUTES.FINANCE_TRANSACTION_HISTORY}`;

      navigate(
        `${to}?${SelectedCompanyParam}=${transaction.companyId}&${SelectedTransactionParam}=${transaction.id}`
      );
    },
    [navigate]
  );

  return { navigateToTransactionHistory };
}
